// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*! muse-css:product:qKwibe */\n._3ORaF{align-items:center;border:1px solid var(--audio-form-default);border-radius:var(--audio-radius-1);display:flex;gap:var(--audio-spacing-8);padding:var(--audio-spacing-8)}.DbuHV{align-items:center;display:flex;flex-shrink:0;height:60px;justify-content:center;position:relative;width:60px}._93n-V{bottom:0;height:100%;left:0;position:absolute;right:0;top:0;width:100%}.r5S1r{display:flex;flex-direction:column;flex-grow:1;gap:var(--audio-spacing-4);justify-content:center;min-width:0}.K_cJ8{height:1.25rem;width:80%}.Vwdle{height:1rem;width:50%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": "_3ORaF",
	"coverBox": "DbuHV",
	"coverImage": "_93n-V",
	"main": "r5S1r",
	"title": "K_cJ8",
	"author": "Vwdle"
};
export default ___CSS_LOADER_EXPORT___;
